import Window from "../Window";
import WebView from "../WebView";

const MediaView = ({ hash, name, data, closeWindow, onFocus }) => {
  return (
    <Window
      id={hash}
      top={0}
      left={0}
      name={name}
      onCancel={closeWindow}
      onClick={onFocus}
    >
      <WebView id={hash} width={"100%"} height={"100%"} data={data} />
    </Window>
  );
};

export default MediaView;
